// extracted by mini-css-extract-plugin
export var modal = "_ja-0";